const routes = [
  {
    path: '/municipalities',
    name: 'municipalities',
    component: () => import('./views/UserMunicipalities/index.vue'),
    meta: {
      title: 'Мои Муниципалитеты',
    },
  },

];

export default routes;
